import { ChangeDetectionStrategy, Component } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";

import type { TranslationLanguage } from "../../types/translation.types";
import { TranslatableFieldBase } from "./translatable-field.base";
import { TranslatableShellComponent } from "./translatable-shell.component";
import { atLeastOneLocaleExpression } from "./translatable.utils";

export interface InputTranslatableFieldProps {
  fieldBaseName: string;
  sourceLanguage?: TranslationLanguage;
  showTranslateButton?: boolean;
  label?: string;
  placeholder?: string;
  maxLength?: number;
  /**
   * Require at least one locale to be filled. Replaces the standard
   * `required` prop, which would only check the NL slot via Formly's
   * built-in `Validators.required`.
   */
  requireOneLocale?: boolean;
}

@Component({
  selector: "app-formly-input-translatable",
  standalone: true,
  imports: [FormsModule, TranslateModule, TranslatableShellComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <app-translatable-shell [field]="this">
      <ng-template let-lang>
        <input
          type="text"
          class="w-full border-0 outline-none bg-transparent p-0 font-base text-[15px]"
          [placeholder]="props['placeholder'] || '' | translate"
          [maxLength]="props['maxLength'] || 500"
          [ngModel]="getFieldValue(lang)"
          (ngModelChange)="setFieldValue(lang, $event)"
          (blur)="markTouched()"
        />
      </ng-template>
    </app-translatable-shell>
  `,
})
export class InputTranslatableFieldComponent extends TranslatableFieldBase {
  override defaultOptions = {
    props: {
      fieldBaseName: "",
      sourceLanguage: "nl" as TranslationLanguage,
      showTranslateButton: true,
      maxLength: 500,
    },
    validators: {
      atLeastOneLocale: {
        expression: atLeastOneLocaleExpression,
        message: "This field is required",
      },
    },
  };
}
